<div class="page-header">
  
  @if(!isMobile) {
    <h1 class="page-title">Load Search</h1>
  } @else {
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Searches: 
        <span class="ml-3" [class.no-results]="loadSearches.length === 0">
          {{ loadSearches.length | number }}
        </span>
      }
    </div>
  }

  <div class="header-actions">

    @if(!isMobile) {
      <button
        mat-flat-button
        matTooltip="New Search"
        (click)="openFiltersDialog()"
        class="search-button"
      >
        <mat-icon>add</mat-icon>
        Search
      </button>
    } @else {

      <button 
        mat-icon-button 
        class="create-button" 
        (click)="openFiltersDialog()" 
        matTooltip="Start New Search" 
        [disabled]="loading"
      >
        <mat-icon>add</mat-icon>
      </button>

    }
  </div>
</div>

<br />

@if (isMobile) {

  @if (loadSearches.length === 0) {
    <div class="yellow-container text-center">
      You have no saved searches. Click the (+) button to start a new search.
    </div>
  } @else {
    <mat-list class="mobile-search-list">

    @for (search of loadSearches; track search.id) {

      <mat-list-item
        class="mobile-search-item"
        [routerLink]="['/loads/searches', search.id]"
      >

        <div matListItemTitle class="mobile-search-title">
          {{ search.name }}
        </div>

        <div matListItemMeta class="list-actions">

          <button
            mat-icon-button
            type="button"
            (click)="deleteSearch(search, $event)"
            matTooltip="Delete Search"
          >
            <mat-icon>close</mat-icon>
          </button>

        </div>

      </mat-list-item>

    }

  </mat-list>
  }

} @else {

  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [(selectedIndex)]="selectedIndex"
    [preserveContent]="true"
    [style.visibility]="loadSearches.length > 0 ? 'visible' : 'hidden'"
  >

    @for (search of loadSearches; track search.id; let i = $index) {

      <mat-tab>

        <ng-template mat-tab-label>

          <span>{{ search.name }}</span>

          <button
            mat-icon-button
            type="button"
            (click)="deleteSearch(search, $event)"
            class="close-btn ml-10"
            matTooltip="Close Search"
          >
            <mat-icon>close</mat-icon>
          </button>

        </ng-template>

        <ng-template matTabContent>

          <br />

          <app-load-search
            [search]="search"
            [active]="selectedIndex === i"
          ></app-load-search>

        </ng-template>

      </mat-tab>

    }

  </mat-tab-group>

}